import { Api_EndPoints } from "../utils/Api_EndPoints";
import { useMutation } from "@tanstack/react-query";
import http_payroll from "../utils/http_payroll";
import http_formData from "../utils/http_formData";
const applyLeave = async (input) => {
  const {data} = await http_formData.post(Api_EndPoints.SaveApplyLeave, input);
  return data;
};

const approveLeave = async (input) => {
  const data = await http_payroll.post(Api_EndPoints.ApproveLeave, input);
  return data;
};

const rejectLeave = async (input) => {
  const data = await http_payroll.post(Api_EndPoints.RejectLeave, input);
  return data;
};

export const useSaveApplyLeaveMutation = () => {
  return useMutation({
    mutationFn: applyLeave,
  });
};

export const useApproveLeaveMutation = () => {
  return useMutation({
    mutationFn: approveLeave,
  });
};

export const useRejectLeaveMutation = () => {
  return useMutation({
    mutationFn: rejectLeave,
  });
};
